const QUICK_DEPOSIT_NAMESPACE = "QUICK_DEPOSIT_NAMESPACE";
const SET_SAVED_CARDS = "SET_SAVED_CARDS";
const SET_SAVED_CARDS_INITIALISED = "SET_SAVED_CARDS_INITIALISED";
const SET_PAYMENT_PROCESSING = "SET_PAYMENT_PROCESSING";
const SET_PAYMENT_RESULT = "SET_PAYMENT_RESULT";
const SET_PAYMENT_ERROR_STATUS_CODE = "SET_PAYMENT_ERROR_STATUS_CODE";
var IPaymentResult;
(function(IPaymentResult2) {
  IPaymentResult2[IPaymentResult2["SUCCESS"] = 0] = "SUCCESS";
  IPaymentResult2[IPaymentResult2["ERROR"] = 1] = "ERROR";
  IPaymentResult2[IPaymentResult2["INITIAL"] = 2] = "INITIAL";
})(IPaymentResult || (IPaymentResult = {}));

export { IPaymentResult, QUICK_DEPOSIT_NAMESPACE, SET_PAYMENT_ERROR_STATUS_CODE, SET_PAYMENT_PROCESSING, SET_PAYMENT_RESULT, SET_SAVED_CARDS, SET_SAVED_CARDS_INITIALISED };
